import { ColorOptions } from '@jfs/ui-new'

export enum CardTypes {
  CREDIT_CARD = 'creditCard',
  DEBIT_CARD = 'debitCard',
}

export interface CardNumberInputProps {
  ID?: string
  type?: CardTypes
  fieldName?: string
  setFieldValue?: (fieldName: string, value: number | string) => {}
  error?: string
  touched?: boolean
  onBlur?: () => {}
  onChangeText?: (cardNumber: string, cardVendor: CardVendors) => void
  value: string
  onCustomBlur: (cardVendor: CardVendors, cardNumber: string) => void
  testID?: string
  rcColor?: ColorOptions | Array<ColorOptions>
  hideLabel?: boolean
  showBorder?: boolean
  theme?: any
  placeholder?: string
  fontType?: any
}

export interface NewCardProps {
  navigation: any
  ID?: string
}

export interface HeaderProps {
  ID?: string
  type: CardTypes
  amount: string
}

export enum CardVendors {
  NONE = 'none',
  RUPAY = 'rupay',
  MAESTRO = 'maestro',
  DISCOVER = 'discover',
  DINERS = 'diners',
  MASTER_CARD = 'mastercard',
  AMEX = 'amex',
  VISA = 'visa',
}
